import type {PackagesListDto} from '../../typedef';
import type {PackageSizesList, PackagesAcc} from '../typedef';

export type ParsePackages = {
    packagesAcc: PackagesAcc,
    packageSizesList: PackageSizesList,
};
export const parsePackages = (data: PackagesListDto): ParsePackages => {
    const packagesAcc = {} as PackagesAcc;
    const packageSizesList = data.map(item => {
        const {packageSize} = item;
        if (packageSize) {
            packagesAcc[packageSize] = item;
        }
        return packageSize;
    }).filter(item => item);
    return {
        packagesAcc,
        packageSizesList,
    };
};
